module.exports = __webpack_public_path__ + "static/wescef-thanks-61acb22185c7a9e0e16701dc69ca69a9.png";